import React, { useState } from "react";
import { motion } from "framer-motion";

import "./ColorControls.scss";

const ColorControls = ({ selectedColor, onSelect }: ColorControlsProps) => {
  return (
    <div className="mp-templates-profileimagemodal--main-color-controls">
      {colors.map((value, index) => {
        return (
          <ColorButton
            key={`color-button-${index}`}
            color={value}
            onClick={(value) => {
              onSelect(value);
            }}
            selected={selectedColor === value}
          />
        );
      })}
    </div>
  );
};

export default ColorControls;

const colors = [
  "#f27277",
  "#f7941d",
  "#ffcb05",
  "#00ae4d",
  "#44c8f5",
  "#8f53a1",
];

interface ColorControlsProps {
  selectedColor: string;
  onSelect: (color: string) => void;
}

const ColorButton = ({ color, selected, onClick }: ColorButtonProps) => {
  const [animate, setAnimate] = useState("init");

  return (
    <motion.div
      className={`color-button ${selected ? "selected" : ""}`}
      style={{ backgroundColor: color }}
      onClick={() => {
        onClick(color);
      }}
      animate={animate}
      onMouseDown={() => setAnimate("down")}
      onMouseUp={() => setAnimate("up")}
      onTouchStart={() => setAnimate("down")}
      onTouchEnd={() => setAnimate("up")}
      variants={{
        init: { scale: selected ? 1.2 : 1 },
        down: { scale: 0.95 },
        up: { scale: selected ? 1.2 : 1 },
      }}
    />
  );
};
interface ColorButtonProps {
  color: string;
  selected: boolean;
  onClick: (value: string) => void;
}
